import { CircularProgress, Typography } from "@mui/material"
import React from "react"
import ImageMapper from "react-img-mapper"
import json from "./../../assets/hockey_equipment.json"
import EquipmentPopUpComponent from "./EquipmentPopUpComponent.js"
import { equipment_data } from "./../../assets/EquipmentContent.js"

class EquipmentTabComponent extends React.Component {
	constructor() {
		super()
		this.state = {
			isLoading: false,
			displayPopUp: false,
			displayTitle: false,
			selectedItem: null,
		}
	}

	showPopup = (area, i, e) => {
		//console.log(area)
		const foundItem = equipment_data.find((item) => {
			return item.id === area.name
		})
		//console.log(foundItem)
		if (foundItem) {
			this.setState({
				selectedItem: foundItem,
				displayPopUp: true,
			})
		}
	}

	handlePopUpClose = () => {
		this.setState({
			displayPopUp: false,
		})
	}

	toggleDisplayedTitle = (area, i, e) => {
		this.setState({
			displayTitle: !this.state.displayTitle,
		})
	}

	handle_img_load = (e, dimensions) => {
		this.forceUpdate()
		console.log("update!")
	}

	render() {
		const MAP = {
			name: "equipment-map",
			areas: json,
		}
		return (
			<div className="content">
				<Typography variant="h5">
					Haz "click" en los elementos del jugador para ver los detalles del
					equipamiento que usamos.
				</Typography>
				<Typography variant="caption">
					(Sino funciona correctamente prueba cambiando de pestaña y vuelve a
					esta)
				</Typography>
				<br></br>
				<div
					style={{
						minHeight: 700,
						minWidth: 700,
						width: "auto",
						height: "auto",
					}}
				>
					<ImageMapper
						onMouseEnter={this.toggleDisplayedTitle.bind(this)}
						onMouseLeave={this.toggleDisplayedTitle.bind(this)}
						onClick={this.showPopup.bind(this)}
						onLoad={this.handle_img_load.bind(this)}
						src={
							"https://firebasestorage.googleapis.com/v0/b/uwhmadridweb.appspot.com/o/CenDKZxWwAAEK_i.jpg?alt=media&token=65381e13-6b46-49cc-adaf-842c7c0080c0"
						}
						map={MAP}
						parentWidth={600}
						responsive
					></ImageMapper>
				</div>

				<br></br>
				{this.state.displayPopUp ? (
					<EquipmentPopUpComponent
						visible={this.state.displayPopUp}
						equipment={this.state.selectedItem}
						onClose={this.handlePopUpClose.bind(this)}
					/>
				) : null}
			</div>
		)
	}
}

export default EquipmentTabComponent
